import type { EnergyDataAvailabilityPageState } from "../hooks/useEnergyDataAvailabilityPageState";

export function getSearchParamsFromEnergyDataAvailabilityPageState(
  pageState: EnergyDataAvailabilityPageState
) {
  const searchParams = new URLSearchParams();

  searchParams.set("firstDate", pageState.firstDate.toISODate());
  searchParams.set("lastDate", pageState.lastDate.toISODate());
  searchParams.set("selectedSiteId", pageState.selectedSiteId || "");
  searchParams.set("searchTerm", pageState.searchTerm || "");

  return searchParams;
}
